import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Container, Spinner, Row } from "react-bootstrap";

import { checkTeacherApi } from "../../../../../utility/api/apiList";

import {
  showSuccessAlert,
  showDangerAlert,
  closeAlert,
} from "../../../../../redux/actions/alert/alertActions";

import ButtonComponent from "../../../button";
import InputComponent from "../../../form/input";

import { TeacherIDForm, MessageForm } from "./styledActivityModal";

export const MessageFormComponent = ({
  title,
  titleDetail,
  buttonName,
  handleSendMessage,
  loading,
}) => {
  const { register, handleSubmit } = useForm({});
  return (
    <MessageForm
      onSubmit={handleSubmit(handleSendMessage)}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <Row className="d-flex flex-row justify-content-center mt-3 mt-md-4 mb-1">
        <p className="send-message w-auto d-inline-block m-0 p-0">{title}</p>
        {titleDetail && (
          <p className="teacher-name w-auto d-inline-block m-0">{titleDetail}</p>
        )}
      </Row>
      <InputComponent
        as="textarea"
        type="text"
        maxLength="200"
        register={register("textarea_message")}
        containerClass="textarea-message"
        error="پیام شما می‌تواند شامل 200 کاراکتر باشد."
      />
      <ButtonComponent type="submit" className="mb-2 mb-md-3 mt-2 mt-md-3">
        {loading ? (
          <Spinner
            as="span"
            animation="border"
            role="status"
            aria-hidden="true"
            size="sm"
          />
        ) : (
          buttonName
        )}
      </ButtonComponent>
    </MessageForm>
  );
};

const ActivityModal = ({ simReportData, loading, activityMessageRun }) => {
  const [checkTeacher, setCheckTeacher] = useState({
    teacherId: null,
    isIncorrectId: true,
    teacherName: null,
    teacherGender: null,
  });
  const dispatch = useDispatch();
  const teacherGender = ["آقای", "خانم", ""];

  const schema = yup.object().shape({
    teacher_id: yup
      .string()
      .test("len", "شناسه کاربری باید 10 کاراکتر باشد!", (val) => val?.length === 10)
      .required("شناسه کاربری معلم نباید خالی باشد!"),
  });

  const {
    register,
    handleSubmit,
    setError,
    setFocus,
    formState: { isValid, errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    setFocus("teacher_id");
  }, []);

  const handleCheckTeacherID = (formValue) => {
    activityMessageRun
      .checkTeacherIdRun(
        undefined,
        undefined,
        `${checkTeacherApi}${formValue.teacher_id}/`
      )
      .then((response) => {
        setCheckTeacher({
          teacherId: response.data.user_id,
          isIncorrectId: false,
          teacherName: response.data.full_name,
          teacherGender: response.data.gender,
        });
      })
      .catch(() => {
        setCheckTeacher({
          ...checkTeacher,
          isIncorrectId: true,
        });
        setError("teacher_id", {
          type: "test",
          message: "شناسه کاربری وارد شده اشتباه است .",
        });
      });
  };

  const handleSendActivity = (data) => {
    let activityData = {
      type: 4,
      recipient_user: checkTeacher.teacherId,
      sim_report_id: simReportData.id,
      title: "sim_report",
      content: data?.textarea_message ? data?.textarea_message : "",
    };

    activityMessageRun
      .sendActivityRun(activityData)
      .then(() => {
        dispatch(closeAlert());
        dispatch(
          showSuccessAlert(
            `گزارش شما برای  ${teacherGender[checkTeacher.teacherGender]}  ${
              checkTeacher.teacherName
            } با موفقیت ارسال شد.`
          )
        );
      })
      .catch((error) => {
        dispatch(closeAlert());
        dispatch(
          showDangerAlert(
            error.response.data[0]
              ? error.response.data[0]
              : "ارسال گزارش ناموفق بود،دوباره امتحان کنید"
          )
        );
      });
  };
  return (
    <Container className="w-100 mx-auto p-2 d-flex flex-column align-items-center">
      <TeacherIDForm onSubmit={handleSubmit(handleCheckTeacherID)}>
        <label className="label-teacher-id w-100 text-center mb-1">
          شناسه کاربری معلم را وارد کنید.
        </label>
        <InputComponent
          type="text"
          register={register("teacher_id")}
          error={errors.teacher_id?.message}
          className={errors?.teacher_id && "invalid-text"}
          containerClass={`teacher-id-input mx-auto ${
            errors?.teacher_id && "invalid-input"
          }`}
        />
        <ButtonComponent
          type="submit"
          className="mt-3 d-block mx-auto"
          disabled={!isValid}
        >
          {loading.checkTeacherIdIsLoading ? (
            <Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
              size="sm"
            />
          ) : (
            "تایید"
          )}
        </ButtonComponent>
      </TeacherIDForm>
      {!checkTeacher.isIncorrectId && (
        <MessageFormComponent
          title="پیام به معلم:&nbsp;"
          titleDetail={`${teacherGender[checkTeacher.teacherGender]} 
          ${checkTeacher.teacherName}`}
          buttonName="تایید ارسال گزارش"
          handleSendMessage={handleSendActivity}
          loading={loading.sendActivityIsLoading}
        />
      )}
    </Container>
  );
};

export default ActivityModal;
